export default "__VITE_ASSET__DVpyQUTK__"